function escapeCharacters(str) {
  return str.replace(/[.*+?^${}()|[\]\\]/g, '\\$&'); // Escapes any special characters
}

export function escapeCharactersRegex(str) {
  return new RegExp(`[${escapeCharacters(str)}]`);
}
